import { Box, Fade, Image, Text } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import Caret from '../../assets/images/caret_up.svg';
import { useTranslation } from 'react-i18next';
import { LanguageOptions, LanguageSwitcherModalProps } from '../../interfaces/components';
import { languageKeys, languageKeysArr, languageNames, languageOptions } from '../../utils/helper';

const LanguageSwitcher = ({ onLanguageSelect }: LanguageSwitcherModalProps) => {
  const { i18n } = useTranslation();
  const [selectedValue, setSelectedValue] = useState('ENGLISH');
  const [showOptions, setShowOptions] = useState(false);
  const [fadeVisible, setFadeVisible] = useState(false);
  const [optionsToDisplay, setOptionsToDisplay] = useState<LanguageOptions[]>([]);

  const toggleOptions = () => {
    setShowOptions((value) => !value);
  };

  const onOptionSelect = (value: LanguageOptions) => {
    localStorage.setItem('locale', value.key);
    onLanguageSelect(value.name);
    toggleOptions();
    i18n.changeLanguage(value.key);

    setTimeout(() => {
      setSelectedValue(value.name);
      window.changeUrls();
    }, 250);
  };

  useEffect(() => {
    if (selectedValue) {
      const newOptions = languageOptions.filter((option: LanguageOptions) => option.name !== selectedValue);
      setOptionsToDisplay(newOptions);
    }
  }, [selectedValue]);

  useEffect(() => {
    // console.log('Locations', window.location);
    const urlParams = new URLSearchParams(window.location.search);
    const locale = urlParams.get('locale');

    if (locale && locale != null) {
      if (languageKeysArr.indexOf(locale) !== -1) {
        localStorage.setItem('locale', locale);
        setSelectedValue(languageNames[locale]);
        i18n.changeLanguage(locale);
      }
    }
  }, []);

  useEffect(() => {
    if (i18n.language !== languageKeys[selectedValue]) {
      localStorage.setItem('locale', i18n.language);
      setSelectedValue(languageNames[i18n.language]);
    }
  }, [i18n.language]);

  useEffect(() => {
    if (showOptions) {
      setTimeout(() => {
        setFadeVisible(true);
      }, 100);
    } else {
      setFadeVisible(false);
    }
  }, [showOptions]);

  return (
    <Box>
      {showOptions && (
        <Fade in={fadeVisible}>
          <Box
            zIndex={8}
            // opacity={fadeVisible ? 1 : 0}
            // visibility={fadeVisible ? 'visible' : 'hidden'}
            // transition="all 0.5s"
          >
            {optionsToDisplay.map((option: LanguageOptions) => (
              <Box
                w="130px"
                h="40px"
                borderRadius="0px"
                bg="#fff"
                display="flex"
                justifyContent="center"
                alignItems="center"
                border="1px solid grey"
                cursor="pointer"
                key={option.key}
                onClick={() => onOptionSelect(option)}
              >
                <Text
                  fontWeight="400"
                  fontFamily="JosefinSans"
                  fontSize={['12px', '12px', '14px', '14px', '14px']}
                  lineHeight={['14px', '14px', '18px', '18px', '18px']}
                  color="#859395"
                >
                  {option.name}
                </Text>
              </Box>
            ))}
          </Box>
        </Fade>
      )}
      <Box
        w="130px"
        h="40px"
        borderRadius="0px"
        bg="#fff"
        display="flex"
        justifyContent="center"
        alignItems="center"
        border="1px solid #859395"
        cursor="pointer"
        onClick={toggleOptions}
        mt="2"
      >
        <Text
          fontWeight="400"
          fontFamily="JosefinSans"
          fontSize={['12px', '12px', '14px', '14px', '14px']}
          lineHeight={['14px', '14px', '18px', '18px', '18px']}
          userSelect="none"
          color="#859395"
        >
          {selectedValue}
        </Text>
        <Image
          ml="10px"
          src={Caret}
          w="15px"
          h="15px"
          transform={showOptions ? 'rotate(180deg);' : 'rotate(0deg);'}
          objectFit="contain"
          alt="hover"
          cursor="pointer"
          userSelect="none"
        />
      </Box>
    </Box>
  );
};

export default LanguageSwitcher;
